import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const sxStyles = createTypedSxStyles({
  groupNotFoundIconWrapper: {
    display: 'inline-flex',
    flexShrink: 0,
    marginLeft: '8px'
  },
  groupNotFoundIcon: {
    color: capitalDesignTokens.foundations.colors.red700
  }
});
